// extracted by mini-css-extract-plugin
export var activities = "activities-module--activities--YlT0D";
export var table = "activities-module--table--73QW8";